'use client'

import { testIds } from '@/root/shared-consts'
import { ComponentProps, FC } from 'react'
import { Button } from '@/root/ui/tuuleliinid'
import { BackIcon } from '@/root/ui/shared'
import cn from 'classnames'

interface NextButtonProps extends ComponentProps<typeof Button> {
  subtitle: string
  title: string
}

export const BackButton: FC<NextButtonProps> = ({ title, subtitle, ...buttonProps }) => {
  const textClass = 'text-neutral-medium-light text-end leading-tight'

  return (
    <Button
      variant="outlined"
      disabled={buttonProps.disabled}
      onClick={buttonProps.onClick}
      data-testid={testIds.bottomNav.goBackNext}
    >
      <div className="size-6">
        <BackIcon color="neutral-medium-light" />
      </div>
      <div className="flex size-max flex-col flex-wrap items-end justify-around">
        <div className={cn(textClass, 'text-2xl font-bold')}>{title}</div>
        <div className={cn(textClass, 'text-sm')}>{subtitle}</div>
      </div>
    </Button>
  )
}
